<div
  class="component-container"
  [style.backgroundColor]="
    config().backgroundColorBySubType?.[subType()] ?? config().backgroundColor
  "
  data-cy="won_message"
>
  <div class="right {{ environment.retailerName }}">
    <p
      class="win-first-label {{ environment.retailerName }}"
      [style]="{
        color: config().right.winFirstLabel.color,
        fontFamily: config().right.winFirstLabel.fontFamily,
      }"
    >
      {{ config().right.winFirstLabel.text }}
    </p>
    <p
      class="win-second-label {{ environment.retailerName }}"
      [style]="{
        color: config().right.winSecondLabel.color,
        fontFamily: config().right.winSecondLabel.fontFamily,
      }"
    >
      {{ config().right.winSecondLabel.text }}
    </p>

    @let pictureConfig = config().right.picture;
    @if (pictureConfig) {
      <img
        [src]="pictureConfig.imageUrl"
        [alt]="pictureConfig.alternativeText"
        class="win-vector"
      />
    }
  </div>

  <div class="left">
    <img
      [src]="config().left.backgroundImage.imageUrl"
      [alt]="
        config().left.backgroundImage.alternativeText | replaceVars: amount()
      "
    />
    @let splitCurrencyAmount = config().splitCurrencyAmount;
    @if (splitCurrencyAmount) {
      @let amountParts = amount() | formatAmountParts;
      <p
        class="amount split-amount"
        [style]="{
          color: config().left.amount.color,
          fontStyle: config().left.amount.fontStyle,
          fontFamily: config().left.amount.fontFamily,
        }"
      >
        <span class="amount-currency">{{ amountParts.currency }}</span>
        <span class="amount-integer">{{ amountParts.integer }}</span>
        <span class="amount-fraction">{{ amountParts.fraction }}</span>
      </p>
    } @else {
      <p
        class="amount"
        [style]="{
          color: config().left.amount.color,
          fontStyle: config().left.amount.fontStyle,
          fontFamily: config().left.amount.fontFamily,
        }"
      >
        {{ amount() | formatReward }}
      </p>
    }
  </div>
</div>
